import React, { useState, useEffect } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import { useLocale } from './contexts/LocaleContext';
import { useIntl } from 'react-intl';
import useAuth from './hooks/useAuth';
import Header from './header';
import { useNavigate, useParams } from 'react-router-dom';
import DataTable4 from './DataTable4';
import { Grid, Autocomplete, TextField } from '@mui/material';
import DateRangePicker from 'DateRangePicker';
import ToggleButton from 'components/ToggleButton';

const Reports = () => {
  const intl = useIntl();
  const [data, setData] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [clients, setClients] = useState([])
  const [activities, setActivities] = useState([])
  const [employees, setEmployees] = useState([])
  const { getToken } = useAuth();
  const [alignment, setAlignment] = React.useState('client');

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  function localeFormat(id) {
    return intl.formatMessage({ id });
  }

  async function fetchJobs() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/all-jobs`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.ok) {
        const data = await response.json();
        setData(data);
        setFilteredRows(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchClients() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/client`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.ok) {
        const data = await response.json();
        setClients(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchActivities() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/activity`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.ok) {
        const data = await response.json();
        setActivities(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchEmployees() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/employees`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'GET',
        headers
      });
      if (response.ok) {
        const data = await response.json();
        setEmployees(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchJobs();
    fetchActivities();
    fetchEmployees();
    fetchClients();
  }, []);

  return (
    <div>
      <div style={{ height: 'auto', width: '100%' }}>
        <Grid container>
          <Grid item xs={12}>
            <ToggleButton alignment={alignment} onChange={handleChange} />
            <DateRangePicker
              data={data}
              clients={clients}
              activities={activities}
              employees={employees}
              setFilteredRows={setFilteredRows}
              alignment={alignment}
            />
          </Grid>
          <Grid item xs={12}>
            <DataTable4 data={filteredRows || []} localeFormat={localeFormat} exportButton={true} footer="total" />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Reports;